// TODO: The following aren't tracked by CompanyIntegrationModel yet
// Chrome extension

// TODO: These properties don't match the names from app/js/bae/constants.js
// It might be worth writing a migration to deduplicate the two objects

export enum IntegrationNames {
  asana = 'asana',
  azure = 'azure',
  azureDevops = 'azureDevops',
  clickup = 'clickup',
  discord = 'discord',
  freshdesk = 'freshdesk',
  gitHub = 'github',
  gong = 'gong',
  gSuite = 'gsuite',
  helpscout = 'helpscout',
  hubspot = 'hubspot',
  intercom = 'intercom',
  jira = 'jira',
  linear = 'linear',
  microsoftTeams = 'microsoftteams',
  oidc = 'oidc',
  okta = 'okta',
  oneLogin = 'onelogin',
  salesforce = 'salesforce',
  segment = 'segment',
  slack = 'slack',
  tldv = 'tldv',
  zapier = 'zapier',
  zendesk = 'zendesk',
  zoom = 'zoom',
  // review integrations
  appStoreReviews = 'appstore-reviews',
  capterraReviews = 'capterra-reviews',
  g2Reviews = 'g2-reviews',
  playStoreReviews = 'playstore-reviews',
  productHuntReviews = 'producthunt-reviews',
  salesforceReviews = 'salesforce-reviews',
  shopifyReviews = 'shopify-reviews',
  trustpilotReviews = 'trustpilot-reviews',
  trustradiusReviews = 'trustradius-reviews',
  wordpressReviews = 'wordpress-reviews',
}

export const publicReviewIntegrations = [
  IntegrationNames.appStoreReviews,
  IntegrationNames.capterraReviews,
  IntegrationNames.g2Reviews,
  IntegrationNames.playStoreReviews,
  IntegrationNames.productHuntReviews,
  IntegrationNames.salesforceReviews,
  IntegrationNames.shopifyReviews,
  IntegrationNames.trustpilotReviews,
  IntegrationNames.trustradiusReviews,
  IntegrationNames.wordpressReviews,
] as const;

export const LinkableIntegrations = [
  IntegrationNames.asana,
  IntegrationNames.azureDevops,
  IntegrationNames.clickup,
  IntegrationNames.gitHub,
  IntegrationNames.jira,
  IntegrationNames.linear,
] as const;

export type LinkableIntegrationNames = (typeof LinkableIntegrations)[number];

type reviewIntegrationKeys = [
  IntegrationNames.appStoreReviews,
  IntegrationNames.capterraReviews,
  IntegrationNames.g2Reviews,
  IntegrationNames.playStoreReviews,
  IntegrationNames.productHuntReviews,
  IntegrationNames.salesforceReviews,
  IntegrationNames.shopifyReviews,
  IntegrationNames.trustpilotReviews,
  IntegrationNames.trustradiusReviews,
  IntegrationNames.wordpressReviews,
];

type ReviewIntegration = reviewIntegrationKeys[number];
type CoreIntegration = Exclude<IntegrationNames, ReviewIntegration>;

export const isIntegrationName = (name: string): name is IntegrationNames => {
  return Object.values(IntegrationNames).includes(name as IntegrationNames);
};

// This map is used during plan changes to guide users to uninstall unsupported integrations.
// Review integrations are excluded because they:
// (1) don’t have settings pages and
// (2) are available on all plans,
// so they don’t require special handling
export const IntegrationNameToSettingPathMap = {
  [IntegrationNames.asana]: { name: 'Asana', path: 'asana' },
  [IntegrationNames.azure]: { name: 'Azure', path: 'azure' },
  [IntegrationNames.azureDevops]: { name: 'Azure DevOps', path: 'azure-devops' },
  [IntegrationNames.clickup]: { name: 'Clickup', path: 'clickup' },
  [IntegrationNames.discord]: { name: 'Discord', path: 'discord' },
  [IntegrationNames.gitHub]: { name: 'GitHub', path: 'github' },
  [IntegrationNames.freshdesk]: { name: 'Freshdesk', path: 'freshdesk' },
  [IntegrationNames.gong]: { name: 'Gong', path: 'gong' },
  [IntegrationNames.gSuite]: { name: 'GSuite', path: 'gsuite' },
  [IntegrationNames.helpscout]: { name: 'Help Scout', path: 'helpscout' },
  [IntegrationNames.hubspot]: { name: 'HubSpot', path: 'hubspot' },
  [IntegrationNames.intercom]: { name: 'Intercom', path: 'intercom' },
  [IntegrationNames.jira]: { name: 'Jira', path: 'jira' },
  [IntegrationNames.linear]: { name: 'Linear', path: 'linear' },
  [IntegrationNames.microsoftTeams]: { name: 'Microsoft Teams', path: 'microsoft-teams' },
  [IntegrationNames.oidc]: { name: 'OpenID Connect', path: 'oidc' },
  [IntegrationNames.okta]: { name: 'Okta', path: 'okta' },
  [IntegrationNames.oneLogin]: { name: 'One Login', path: 'onelogin' },
  [IntegrationNames.salesforce]: { name: 'Salesforce', path: 'salesforce' },
  [IntegrationNames.segment]: { name: 'Segment', path: 'segment' },
  [IntegrationNames.slack]: { name: 'Slack', path: 'slack' },
  [IntegrationNames.tldv]: { name: 'tl;dv', path: 'tldv' },
  [IntegrationNames.zapier]: { name: 'Zapier', path: 'zapier' },
  [IntegrationNames.zendesk]: { name: 'Zendesk', path: 'zendesk' },
  [IntegrationNames.zoom]: { name: 'Zoom', path: 'zoom' },
  // using satisfies to ensure that any integrations added to the enum will be included here
} satisfies Record<CoreIntegration, { name: string; path: string }>;
